import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SessionService } from "../../../shared/services/session.service";
import { AlertPopupService } from "../../../shared/services/alert-popup.service";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { RegexEnum } from "../../../core/enums/regex.enum";
import { CUSTOMER_DO_LOGOUT, DeleteAcount, UpdateProfile } from "../../../states/auth/auth.actions";
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModal } from 'src/app/shared/components/dialog/dialog.component';
import { Location } from "@angular/common";

@Component({
    selector: 'app-mobile-profile',
    templateUrl: './mobile-profile.component.html',
    styleUrls: ['./mobile-profile.component.scss']
})
export class MobileProfileComponent implements OnInit {
    public form: FormGroup;

    constructor(
        private sessionService: SessionService,
        private alertPopupService: AlertPopupService,
        public router: Router,
        private formBuilder: FormBuilder,
        private store: Store,
        private dialog: MatDialog,
        private location: Location
    ) {
    }

    public isLogin: boolean = false

    ngOnInit(): void {
        if (this.sessionService?.state?.token) {
            this.isLogin = true
        }
    }

    get image() {
        return this.sessionService?.state?.profile?.image ? this.sessionService?.state?.profile?.image?.USER_PROFILE?.s3url : '../../../../assets/images/dummy/dummyUserImage.jpg'
    }

    get name() {
        const profile = this.sessionService?.state?.profile;
        if (profile) {
            return `${profile.firstName} ${profile.lastName}`;
        }
        return ''
    }

    get mobile() {
        const profile = this.sessionService?.state?.profile;
        const mobile = profile?.mobile || '';

        if (mobile.startsWith('+91')) {
            return mobile.substring(3);
        }

        return mobile;
    }

    backBtnClick() {
        this.location.back();
    }

    doLogout() {
        const confirmationModal = this.dialog.open(ConfirmationModal, {
            width: '352px',
            data: {
                dialogTitle: 'Logout',
                dialogMessage: 'Are you sure, you want to logout?',
                dailogCancelBtnTitle: 'CANCEL',
                dailogSuccessBtnTitle: 'OK',
                params: null,
            },
        });

        confirmationModal.componentInstance.onSuccessEvent.subscribe((params) => {
            this.dialog.closeAll();
            this.store.dispatch(
                new CUSTOMER_DO_LOGOUT({})
            )
            this.sessionService.unsetState();
            localStorage.clear()
            sessionStorage.clear()
            this.router.navigate(['/login']);
        });
    }

}
